import { EventViewData } from 'components/eventView/pages/eventData';
import { GuideQuery_guide } from 'graphql/query/__generated__/GuideQuery';
import { GuideQueryView_guideView } from 'graphql/query/__generated__/GuideQueryView';
import { mapGuideToEventView } from 'libs/utils/mapping/guideToEventMap';
import _ from 'lodash';

function mergeArrays<T>(adminArr: T[], configArr: T[], comparator: (t1: T, t2: T) => boolean): T[] {
    if (!configArr && !adminArr) return [];
    if (!configArr?.length) return adminArr;
    if (!adminArr?.length) return configArr;

    const missing = adminArr.filter((e1) => !configArr.some((e2) => comparator(e1, e2)));
    return [...configArr, ...missing];
}

function mergeStringArrays(adminArr: string[], configArr: string[]) {
    if (!configArr && !adminArr) return [];
    if (!configArr?.length) return adminArr;
    if (!adminArr?.length) return configArr;

    let missing = [];
    if (configArr.includes('...')) {
        const newArr = [...configArr];
        missing = adminArr.filter((item) => !configArr.includes(item));
        newArr.splice(configArr.indexOf('...'), 1, ...missing);
        return newArr;
    }

    // const missing = adminArr.filter((item) => !configArr.includes(item));
    return [...configArr, ...missing];
}

export function mergeGuideToEvent(
    guide: GuideQuery_guide | GuideQueryView_guideView,
    config: EventViewData
): EventViewData {
    if (!guide) {
        return config;
    }

    if (!config) {
        return mapGuideToEventView(guide);
    }

    const admin = mapGuideToEventView(guide);
    const autoMerged = _.merge({}, admin, config);

    return {
        ...autoMerged,
        eventInfo: {
            ...autoMerged.eventInfo,
            order: {
                ...autoMerged.eventInfo.order,
                mobile: mergeStringArrays(
                    admin.eventInfo?.order?.mobile,
                    config.eventInfo?.order?.mobile
                ),
                wide: mergeStringArrays(
                    admin.eventInfo?.order?.wide,
                    config.eventInfo?.order?.wide
                ),
                normal: mergeStringArrays(
                    admin.eventInfo?.order?.normal,
                    config.eventInfo?.order?.normal
                ),
                normalV2: config.eventInfo?.order?.normalV2
                    ? config.eventInfo?.order?.normalV2?.map((configRow) => {
                          const hasDots = configRow.includes('...');
                          if (!hasDots) return configRow;
                          const newArr = [...configRow];
                          const configArr = config.eventInfo?.order?.normalV2.flatMap((e) => e);
                          const adminArr = [
                              ...admin.eventInfo?.order?.primes,
                              ...admin.eventInfo?.order?.normal
                          ].filter(Boolean);
                          const missing = adminArr.filter((item) => !configArr.includes(item));
                          newArr.splice(configArr.indexOf('...'), 1, ...missing);
                          return newArr;
                      })
                    : null
            },
            program: {
                ...autoMerged.eventInfo?.program,
                items: mergeArrays(
                    admin.eventInfo?.program?.items,
                    config.eventInfo?.program?.items,
                    (e1, e2) => e1.programId === e2.programId
                )
            }
        }
    };
}
